import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import FormAlert from 'components/Forms/FormAlert';
import AuthService from 'services/auth';
import DotLoader from 'components/Utlility/DotLoader';
import styles from '../ProfileStyles.module.scss';

const UpdateRoomPin = () => {
    const [formData, setFormData] = useState({
        pin: '',
        confirmPin: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        // Only allow numeric input, max 6 digits
        if (value === '' || (/^\d{0,6}$/.test(value))) {
            setFormData(prev => ({ ...prev, [name]: value }));
            setError('');
            setSuccess('');
        }
    };

    const validateForm = () => {
        if (!formData.pin) {
            setError('Please enter a PIN');
            return false;
        }
        if (formData.pin.length < 4) {
            setError('PIN must be at least 4 digits');
            return false;
        }
        if (formData.pin !== formData.confirmPin) {
            setError('PINs do not match');
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const result = await AuthService.resetPIN(formData.pin, formData.confirmPin);
            if (result.Status === 'Success') {
                setSuccess('Room PIN updated successfully!');
                setFormData({
                    pin: '',
                    confirmPin: ''
                });
            } else {
                setError(result.Message || 'Failed to update Room PIN');
            }
        } catch (err) {
            setError('Failed to update Room PIN. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h2 className={styles.sectionTitle}>Update Room PIN</h2>
            <p className={styles.sectionDescription}>
                Your Room PIN allows players to quickly join your game rooms. Set a memorable PIN between 4-6 digits.
            </p>

            <div className={styles.card}>
                <h3 className={styles.cardTitle}>Set Your Room PIN</h3>
                <p className={styles.cardSubtitle}>
                    Players can use this PIN to find and join your games more easily.
                </p>

                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>New Room PIN</Form.Label>
                        <Form.Control
                            type="text"
                            name="pin"
                            value={formData.pin}
                            onChange={handleChange}
                            placeholder="Enter 4-6 digit PIN"
                            maxLength={6}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            autoComplete="off"
                        />
                        <Form.Text className="text-muted">
                            Choose a PIN that's easy to remember but not too obvious (avoid 1234 or 0000).
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Confirm Room PIN</Form.Label>
                        <Form.Control
                            type="text"
                            name="confirmPin"
                            value={formData.confirmPin}
                            onChange={handleChange}
                            placeholder="Re-enter your PIN"
                            maxLength={6}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            autoComplete="off"
                            isInvalid={formData.confirmPin && formData.pin !== formData.confirmPin}
                        />
                    </Form.Group>

                    <FormAlert variant="danger">{error}</FormAlert>
                    <FormAlert variant="success">{success}</FormAlert>

                    <Form.Group>
                        <button type="submit" className={`${styles.button} ${styles.small}`} disabled={loading}>
                            {loading && <DotLoader size="medium" variant="light" />}
                            {loading ? '' : 'Update Room PIN'}
                        </button>
                    </Form.Group>
                </Form>
            </div>
        </div>
    );
};

export default UpdateRoomPin;
